import { render, staticRenderFns } from "./SitePermissionsPage.vue?vue&type=template&id=0ba71fba&scoped=true"
import script from "./SitePermissionsPage.vue?vue&type=script&lang=js"
export * from "./SitePermissionsPage.vue?vue&type=script&lang=js"
import style0 from "./SitePermissionsPage.vue?vue&type=style&index=0&id=0ba71fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba71fba",
  null
  
)

export default component.exports